class ModalTrigger extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['button']
  }

  static get requiredExternalElements () {
    return ['modal', 'close']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.button.element,
      'click',
      this.showModal.bind(this),
    )

    this.externalEls.close.elements.forEach(closeEl => {
      this.listeners.add(closeEl, 'click', this.hideModal.bind(this))
    })
  }

  showModal () {
    const modalId = this.els.button.element.dataset.modalId
    const modalEls = this.externalEls.modal.elements

    modalEls.forEach(modal => {
      const modalToShow = modal.id === modalId
      modal.setAttribute('aria-hidden', !modalToShow)
    })
  }

  hideModal () {
    const modalId = this.els.button.element.dataset.modalId
    const modalEl = document.getElementById(modalId)

    if (!modalEl) return

    modalEl.setAttribute('aria-hidden', 'true')
  }
}

if (!customElements.get('modal-trigger')) {
  customElements.define('modal-trigger', ModalTrigger)
}
